//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    mergeStatementDivision(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/MergeStatementDivision";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeStatementDivision(_response);
        });
    }

    protected processMergeStatementDivision(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getFuneralHomeStatements(v: string, fromDate?: Date | undefined, toDate?: Date | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<FuneralHomeStatementSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/funeralhomestatements?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFuneralHomeStatements(_response);
        });
    }

    protected processGetFuneralHomeStatements(response: Response): Promise<FuneralHomeStatementSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FuneralHomeStatementSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FuneralHomeStatementSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    removeFuneralHomeStatements(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: RemoveFuneralHomeStatementsRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/removefuneralhomestatements";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveFuneralHomeStatements(_response);
        });
    }

    protected processRemoveFuneralHomeStatements(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRunCommissions(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RunCommissionsSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/runcommissions?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRunCommissions(_response);
        });
    }

    protected processGetRunCommissions(response: Response): Promise<RunCommissionsSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RunCommissionsSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RunCommissionsSearchResponse>(null as any);
    }

    /**
     * @param companyIds (optional) 
     * @param payDay (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    scheduleRunCommission(v: string, companyIds?: number[] | null | undefined, payDay?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/scheduleruncommission?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyIds !== undefined && companyIds !== null)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (payDay === null)
            throw new Error("The parameter 'payDay' cannot be null.");
        else if (payDay !== undefined)
            url_ += "PayDay=" + encodeURIComponent(payDay ? "" + payDay.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScheduleRunCommission(_response);
        });
    }

    protected processScheduleRunCommission(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param companyIds (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    unmatchRunCommission(v: string, companyIds?: number[] | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/unmatchruncommission?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyIds !== undefined && companyIds !== null)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnmatchRunCommission(_response);
        });
    }

    protected processUnmatchRunCommission(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param searchType (optional) 
     * @param searchText (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPayToAgentForCommission(v: string, searchType?: number | undefined, searchText?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayToAgentSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/paytoagentforcommission?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayToAgentForCommission(_response);
        });
    }

    protected processGetPayToAgentForCommission(response: Response): Promise<PayToAgentSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayToAgentSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayToAgentSearchResponse>(null as any);
    }

    /**
     * @param importType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllTraditionalCarrierLookup(v: string, importType?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissions/traditionalcarrierlookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (importType === null)
            throw new Error("The parameter 'importType' cannot be null.");
        else if (importType !== undefined)
            url_ += "importType=" + encodeURIComponent("" + importType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTraditionalCarrierLookup(_response);
        });
    }

    protected processGetAllTraditionalCarrierLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param planStatusId (optional) 
     * @param paymentMethodId (optional) 
     * @param paymentSourceId (optional) 
     * @param searchText (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCommissionPlans(v: string, carrierId?: number | undefined, planStatusId?: number | undefined, paymentMethodId?: number | undefined, paymentSourceId?: number | undefined, searchText?: string | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionPlanSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (planStatusId === null)
            throw new Error("The parameter 'planStatusId' cannot be null.");
        else if (planStatusId !== undefined)
            url_ += "PlanStatusId=" + encodeURIComponent("" + planStatusId) + "&";
        if (paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' cannot be null.");
        else if (paymentMethodId !== undefined)
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        if (paymentSourceId === null)
            throw new Error("The parameter 'paymentSourceId' cannot be null.");
        else if (paymentSourceId !== undefined)
            url_ += "PaymentSourceId=" + encodeURIComponent("" + paymentSourceId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCommissionPlans(_response);
        });
    }

    protected processGetAllCommissionPlans(response: Response): Promise<CommissionPlanSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionPlanSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionPlanSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    addCommissionPlan(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CommissionPlanModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCommissionPlan(_response);
        });
    }

    protected processAddCommissionPlan(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateCommissionPlan(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CommissionPlanModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCommissionPlan(_response);
        });
    }

    protected processUpdateCommissionPlan(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionPlanById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionPlanModel> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionPlanById(_response);
        });
    }

    protected processGetCommissionPlanById(response: Response): Promise<CommissionPlanModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionPlanModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    deleteCommissionPlan(v: string, id: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/{id}";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCommissionPlan(_response);
        });
    }

    protected processDeleteCommissionPlan(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    cloneCommissionPlan(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/clonecommissionplan";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCloneCommissionPlan(_response);
        });
    }

    protected processCloneCommissionPlan(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionLevelsByPlanId(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionLevelModel[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/levels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionLevelsByPlanId(_response);
        });
    }

    protected processGetCommissionLevelsByPlanId(response: Response): Promise<CommissionLevelModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionLevelModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionPlanUsageForContractByPlanId(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionPlanUsageModel> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/usageForContract/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionPlanUsageForContractByPlanId(_response);
        });
    }

    protected processGetCommissionPlanUsageForContractByPlanId(response: Response): Promise<CommissionPlanUsageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionPlanUsageModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionPlanUsageForPolicyByPlanId(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionPlanUsagePolicy[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/usageForPolicy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionPlanUsageForPolicyByPlanId(_response);
        });
    }

    protected processGetCommissionPlanUsageForPolicyByPlanId(response: Response): Promise<CommissionPlanUsagePolicy[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionPlanUsagePolicy[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    _GetRenewalRateByAgeId(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalRateResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/renewalratebyageid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.process_GetRenewalRateByAgeId(_response);
        });
    }

    protected process_GetRenewalRateByAgeId(response: Response): Promise<RenewalRateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalRateResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalAgeByPlanId(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalAgeResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/renewalagebyeplanid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalAgeByPlanId(_response);
        });
    }

    protected processGetRenewalAgeByPlanId(response: Response): Promise<RenewalAgeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalAgeResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionPlanStatussesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/planstatusseslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionPlanStatussesLookup(_response);
        });
    }

    protected processGetCommissionPlanStatussesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionPlanPaymentSourcesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/planpaymentsourceslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionPlanPaymentSourcesLookup(_response);
        });
    }

    protected processGetCommissionPlanPaymentSourcesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionPayFromNameLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/payfromnamelookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionPayFromNameLookup(_response);
        });
    }

    protected processGetCommissionPayFromNameLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentsBySearchTermLookup(searchText: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/getagentbysearchtermlookup/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentsBySearchTermLookup(_response);
        });
    }

    protected processGetAgentsBySearchTermLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionScreenLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionScreenLookupResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/commissionplans/getcommissionscreenlookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionScreenLookup(_response);
        });
    }

    protected processGetCommissionScreenLookup(response: Response): Promise<CommissionScreenLookupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionScreenLookupResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionScreenLookupResponse>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionStatements(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionStatementSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/statements?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionStatements(_response);
        });
    }

    protected processGetCommissionStatements(response: Response): Promise<CommissionStatementSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionStatementSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionStatementSearchResponse>(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @param payDate (optional) 
     * @param statementType (optional) 
     * @param fileType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    generateCommissionStatement(v: string, divisionId?: number | undefined, payDate?: Date | undefined, statementType?: StatementType | undefined, fileType?: StatementFileType | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/statements/generate?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (payDate === null)
            throw new Error("The parameter 'payDate' cannot be null.");
        else if (payDate !== undefined)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        if (statementType === null)
            throw new Error("The parameter 'statementType' cannot be null.");
        else if (statementType !== undefined)
            url_ += "StatementType=" + encodeURIComponent("" + statementType) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateCommissionStatement(_response);
        });
    }

    protected processGenerateCommissionStatement(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @param divisionName (optional) 
     * @param payDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    approveCommissionStatement(v: string, divisionId?: number | undefined, divisionName?: string | null | undefined, payDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/statements/approve?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (divisionName !== undefined && divisionName !== null)
            url_ += "DivisionName=" + encodeURIComponent("" + divisionName) + "&";
        if (payDate === null)
            throw new Error("The parameter 'payDate' cannot be null.");
        else if (payDate !== undefined)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveCommissionStatement(_response);
        });
    }

    protected processApproveCommissionStatement(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @param divisionName (optional) 
     * @param payDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    unapproveCommissionStatement(v: string, divisionId?: number | undefined, divisionName?: string | null | undefined, payDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/statements/unapprove?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (divisionName !== undefined && divisionName !== null)
            url_ += "DivisionName=" + encodeURIComponent("" + divisionName) + "&";
        if (payDate === null)
            throw new Error("The parameter 'payDate' cannot be null.");
        else if (payDate !== undefined)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnapproveCommissionStatement(_response);
        });
    }

    protected processUnapproveCommissionStatement(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @param divisionName (optional) 
     * @param payDay (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    markCommissionAsPaid(v: string, divisionId?: number | undefined, divisionName?: string | null | undefined, payDay?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/statements/markaspaid?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (divisionName !== undefined && divisionName !== null)
            url_ += "DivisionName=" + encodeURIComponent("" + divisionName) + "&";
        if (payDay === null)
            throw new Error("The parameter 'payDay' cannot be null.");
        else if (payDay !== undefined)
            url_ += "PayDay=" + encodeURIComponent(payDay ? "" + payDay.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkCommissionAsPaid(_response);
        });
    }

    protected processMarkCommissionAsPaid(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadFile(v: string, fileName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadFileModel> {
        let url_ = this.baseUrl + "/api/commission/v{v}/statements/downloadfile?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: Response): Promise<DownloadFileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFileModel>(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @param payDate (optional) 
     * @param statementType (optional) 
     * @param fileType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadCommissionStatement(v: string, divisionId?: number | undefined, payDate?: Date | undefined, statementType?: StatementType | undefined, fileType?: StatementFileType | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/statements/download?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "DivisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (payDate === null)
            throw new Error("The parameter 'payDate' cannot be null.");
        else if (payDate !== undefined)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        if (statementType === null)
            throw new Error("The parameter 'statementType' cannot be null.");
        else if (statementType !== undefined)
            url_ += "StatementType=" + encodeURIComponent("" + statementType) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadCommissionStatement(_response);
        });
    }

    protected processDownloadCommissionStatement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param policyImportId (optional) 
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    activateImportedPolicy(v: string, policyImportId?: number | undefined, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/activateimportedpolicy?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyImportId === null)
            throw new Error("The parameter 'policyImportId' cannot be null.");
        else if (policyImportId !== undefined)
            url_ += "policyImportId=" + encodeURIComponent("" + policyImportId) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivateImportedPolicy(_response);
        });
    }

    protected processActivateImportedPolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param policyImportId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    skipPolicyImport(v: string, policyImportId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/skippolicyimport?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyImportId === null)
            throw new Error("The parameter 'policyImportId' cannot be null.");
        else if (policyImportId !== undefined)
            url_ += "policyImportId=" + encodeURIComponent("" + policyImportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSkipPolicyImport(_response);
        });
    }

    protected processSkipPolicyImport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param policyImportId (optional) 
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    terminateImportedPolicy(v: string, policyImportId?: number | undefined, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/terminateimportedpolicy?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyImportId === null)
            throw new Error("The parameter 'policyImportId' cannot be null.");
        else if (policyImportId !== undefined)
            url_ += "policyImportId=" + encodeURIComponent("" + policyImportId) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTerminateImportedPolicy(_response);
        });
    }

    protected processTerminateImportedPolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @param policyNumber (optional) 
     * @param agentWritingNumber (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getExistingPolicies(v: string, companyID?: number | undefined, policyNumber?: string | null | undefined, agentWritingNumber?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ExistingPoliciesSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getexistingpolicies?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyID === null)
            throw new Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (agentWritingNumber !== undefined && agentWritingNumber !== null)
            url_ += "AgentWritingNumber=" + encodeURIComponent("" + agentWritingNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExistingPolicies(_response);
        });
    }

    protected processGetExistingPolicies(response: Response): Promise<ExistingPoliciesSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingPoliciesSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistingPoliciesSearchResponse>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @param agentWritingNumber (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getNonActivatedPolicies(v: string, companyID?: number | undefined, agentWritingNumber?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<NonActivatedPoliciesSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getnonactivatedpolicies?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyID === null)
            throw new Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&";
        if (agentWritingNumber !== undefined && agentWritingNumber !== null)
            url_ += "AgentWritingNumber=" + encodeURIComponent("" + agentWritingNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNonActivatedPolicies(_response);
        });
    }

    protected processGetNonActivatedPolicies(response: Response): Promise<NonActivatedPoliciesSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NonActivatedPoliciesSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NonActivatedPoliciesSearchResponse>(null as any);
    }

    /**
     * @param agentWritingNumber (optional) 
     * @param productID (optional) 
     * @param companyID (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPaymentPlansConfiguration(v: string, agentWritingNumber?: string | null | undefined, productID?: number | undefined, companyID?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PaymentPlansConfigurationResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getpaymentplansconfiguration?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentWritingNumber !== undefined && agentWritingNumber !== null)
            url_ += "AgentWritingNumber=" + encodeURIComponent("" + agentWritingNumber) + "&";
        if (productID === null)
            throw new Error("The parameter 'productID' cannot be null.");
        else if (productID !== undefined)
            url_ += "ProductID=" + encodeURIComponent("" + productID) + "&";
        if (companyID === null)
            throw new Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentPlansConfiguration(_response);
        });
    }

    protected processGetPaymentPlansConfiguration(response: Response): Promise<PaymentPlansConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentPlansConfigurationResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentPlansConfigurationResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyCommissionTypes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyCommissionTypeResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getpolicycommissiontypes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyCommissionTypes(_response);
        });
    }

    protected processGetPolicyCommissionTypes(response: Response): Promise<PolicyCommissionTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyCommissionTypeResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyCommissionTypeResponse>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @param statusID (optional) 
     * @param agentWritingNumber (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyDashboardConfigurations(v: string, companyID?: number | undefined, statusID?: number | undefined, agentWritingNumber?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyDashboardConfigurationResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getpolicydashboardconfigurations?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyID === null)
            throw new Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&";
        if (statusID === null)
            throw new Error("The parameter 'statusID' cannot be null.");
        else if (statusID !== undefined)
            url_ += "StatusID=" + encodeURIComponent("" + statusID) + "&";
        if (agentWritingNumber !== undefined && agentWritingNumber !== null)
            url_ += "AgentWritingNumber=" + encodeURIComponent("" + agentWritingNumber) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyDashboardConfigurations(_response);
        });
    }

    protected processGetPolicyDashboardConfigurations(response: Response): Promise<PolicyDashboardConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyDashboardConfigurationResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDashboardConfigurationResponse>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @param statusID (optional) 
     * @param showAll (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyImportAgentWritingNumbers(v: string, companyID?: number | undefined, statusID?: number | undefined, showAll?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getpolicyimportagentwritingnumbers?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyID === null)
            throw new Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&";
        if (statusID === null)
            throw new Error("The parameter 'statusID' cannot be null.");
        else if (statusID !== undefined)
            url_ += "StatusID=" + encodeURIComponent("" + statusID) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyImportAgentWritingNumbers(_response);
        });
    }

    protected processGetPolicyImportAgentWritingNumbers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyCommissionTypesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getpolicycommissiontypeslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyCommissionTypesLookup(_response);
        });
    }

    protected processGetPolicyCommissionTypesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyImportCompaniesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/getpolicyimportcompanieslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyImportCompaniesLookup(_response);
        });
    }

    protected processGetPolicyImportCompaniesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createPolicyFromAdmin(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreatePolicyModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/createpolicyfromadmin";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePolicyFromAdmin(_response);
        });
    }

    protected processCreatePolicyFromAdmin(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyImportNamesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/policyimportnameslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyImportNamesLookup(_response);
        });
    }

    protected processGetPolicyImportNamesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional) 
     * @param importName (optional) 
     * @param importId (optional) 
     * @return Success
     */
    importPolicy(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined, importName?: string | null | undefined, importId?: string | null | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/importpolicy";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (importName !== null && importName !== undefined)
            content_.append("ImportName", importName.toString());
        if (importId !== null && importId !== undefined)
            content_.append("ImportId", importId.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportPolicy(_response);
        });
    }

    protected processImportPolicy(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param policyImportID (optional) 
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    addPolicyAnnuitySinglePremium(v: string, policyImportID?: number | undefined, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/policies/addPolicyAnnuitySinglePremium?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyImportID === null)
            throw new Error("The parameter 'policyImportID' cannot be null.");
        else if (policyImportID !== undefined)
            url_ += "policyImportID=" + encodeURIComponent("" + policyImportID) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPolicyAnnuitySinglePremium(_response);
        });
    }

    protected processAddPolicyAnnuitySinglePremium(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalPaymentSourceLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewalpaymentsourcelookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalPaymentSourceLookup(_response);
        });
    }

    protected processGetRenewalPaymentSourceLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalTypeLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewaltypelookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalTypeLookup(_response);
        });
    }

    protected processGetRenewalTypeLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalPendingCarrierLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getrenewalpendingcarrierlookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalPendingCarrierLookup(_response);
        });
    }

    protected processGetRenewalPendingCarrierLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalBackoutCarrierLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getrenewalbackoutcarrierlookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalBackoutCarrierLookup(_response);
        });
    }

    protected processGetRenewalBackoutCarrierLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalAgentsOfCarrierLookup(v: string, carrierId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewalagentsofcarrierlookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalAgentsOfCarrierLookup(_response);
        });
    }

    protected processGetRenewalAgentsOfCarrierLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalRecordCounts(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalRecordCountResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewalrecordcounts?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalRecordCounts(_response);
        });
    }

    protected processGetRenewalRecordCounts(response: Response): Promise<RenewalRecordCountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalRecordCountResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalRecordCountResponse>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalReviewLog(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalReviewLogResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewalreviewlog?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalReviewLog(_response);
        });
    }

    protected processGetRenewalReviewLog(response: Response): Promise<RenewalReviewLogResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalReviewLogResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalReviewLogResponse>(null as any);
    }

    /**
     * @param renewalCommissionPlanID (optional) 
     * @param renewalIssueAge (optional) 
     * @param policyProductID (optional) 
     * @param policyEffectiveDate (optional) 
     * @param flatRateMonth (optional) 
     * @param useFlatRateMonth (optional) 
     * @param duration (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalFlatRateCalculationFromAdmin(v: string, renewalCommissionPlanID?: number | undefined, renewalIssueAge?: number | undefined, policyProductID?: number | undefined, policyEffectiveDate?: Date | undefined, flatRateMonth?: number | undefined, useFlatRateMonth?: boolean | undefined, duration?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalFlatRateCalculationResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewalflatratecalculationfromadmin?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (renewalCommissionPlanID === null)
            throw new Error("The parameter 'renewalCommissionPlanID' cannot be null.");
        else if (renewalCommissionPlanID !== undefined)
            url_ += "RenewalCommissionPlanID=" + encodeURIComponent("" + renewalCommissionPlanID) + "&";
        if (renewalIssueAge === null)
            throw new Error("The parameter 'renewalIssueAge' cannot be null.");
        else if (renewalIssueAge !== undefined)
            url_ += "RenewalIssueAge=" + encodeURIComponent("" + renewalIssueAge) + "&";
        if (policyProductID === null)
            throw new Error("The parameter 'policyProductID' cannot be null.");
        else if (policyProductID !== undefined)
            url_ += "PolicyProductID=" + encodeURIComponent("" + policyProductID) + "&";
        if (policyEffectiveDate === null)
            throw new Error("The parameter 'policyEffectiveDate' cannot be null.");
        else if (policyEffectiveDate !== undefined)
            url_ += "PolicyEffectiveDate=" + encodeURIComponent(policyEffectiveDate ? "" + policyEffectiveDate.toISOString() : "") + "&";
        if (flatRateMonth === null)
            throw new Error("The parameter 'flatRateMonth' cannot be null.");
        else if (flatRateMonth !== undefined)
            url_ += "FlatRateMonth=" + encodeURIComponent("" + flatRateMonth) + "&";
        if (useFlatRateMonth === null)
            throw new Error("The parameter 'useFlatRateMonth' cannot be null.");
        else if (useFlatRateMonth !== undefined)
            url_ += "UseFlatRateMonth=" + encodeURIComponent("" + useFlatRateMonth) + "&";
        if (duration === null)
            throw new Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalFlatRateCalculationFromAdmin(_response);
        });
    }

    protected processGetRenewalFlatRateCalculationFromAdmin(response: Response): Promise<RenewalFlatRateCalculationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalFlatRateCalculationResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalFlatRateCalculationResponse>(null as any);
    }

    /**
     * @param policyNumber (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPoliciesByPolicyNumber(v: string, policyNumber?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PoliciesByPolicyNumberResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getpoliciesbypolicynumber?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPoliciesByPolicyNumber(_response);
        });
    }

    protected processGetPoliciesByPolicyNumber(response: Response): Promise<PoliciesByPolicyNumberResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PoliciesByPolicyNumberResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoliciesByPolicyNumberResponse>(null as any);
    }

    /**
     * @param isDurationSort (optional) 
     * @param agentID (optional) 
     * @param carrierID (optional) 
     * @param policyNumber (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPoliciesBySearchTerm(v: string, isDurationSort?: boolean | undefined, agentID?: number | null | undefined, carrierID?: number | undefined, policyNumber?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PoliciesBySearchTermResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getpoliciesbysearchterm?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (isDurationSort === null)
            throw new Error("The parameter 'isDurationSort' cannot be null.");
        else if (isDurationSort !== undefined)
            url_ += "IsDurationSort=" + encodeURIComponent("" + isDurationSort) + "&";
        if (agentID !== undefined && agentID !== null)
            url_ += "AgentID=" + encodeURIComponent("" + agentID) + "&";
        if (carrierID === null)
            throw new Error("The parameter 'carrierID' cannot be null.");
        else if (carrierID !== undefined)
            url_ += "CarrierID=" + encodeURIComponent("" + carrierID) + "&";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPoliciesBySearchTerm(_response);
        });
    }

    protected processGetPoliciesBySearchTerm(response: Response): Promise<PoliciesBySearchTermResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PoliciesBySearchTermResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoliciesBySearchTermResponse>(null as any);
    }

    /**
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyRenewalCommissions(v: string, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyRenewalCommissionsResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getpolicyrenewalcommissions?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyRenewalCommissions(_response);
        });
    }

    protected processGetPolicyRenewalCommissions(response: Response): Promise<PolicyRenewalCommissionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyRenewalCommissionsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param renewalIds (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalDashboardByRenewalIds(v: string, renewalIds?: number[] | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalDashboardSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getrenewaldashboardbyrenewalids?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (renewalIds !== undefined && renewalIds !== null)
            renewalIds && renewalIds.forEach(item => { url_ += "RenewalIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalDashboardByRenewalIds(_response);
        });
    }

    protected processGetRenewalDashboardByRenewalIds(response: Response): Promise<RenewalDashboardSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalDashboardSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalDashboardSearchResponse>(null as any);
    }

    /**
     * @param isDurationSort (optional) 
     * @param agentID (optional) 
     * @param carrierID (optional) 
     * @param policyNumber (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalDashboardSearch(v: string, isDurationSort?: boolean | undefined, agentID?: number | null | undefined, carrierID?: number | undefined, policyNumber?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalDashboardSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getrenewaldashboardsearch?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (isDurationSort === null)
            throw new Error("The parameter 'isDurationSort' cannot be null.");
        else if (isDurationSort !== undefined)
            url_ += "IsDurationSort=" + encodeURIComponent("" + isDurationSort) + "&";
        if (agentID !== undefined && agentID !== null)
            url_ += "AgentID=" + encodeURIComponent("" + agentID) + "&";
        if (carrierID === null)
            throw new Error("The parameter 'carrierID' cannot be null.");
        else if (carrierID !== undefined)
            url_ += "CarrierID=" + encodeURIComponent("" + carrierID) + "&";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalDashboardSearch(_response);
        });
    }

    protected processGetRenewalDashboardSearch(response: Response): Promise<RenewalDashboardSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalDashboardSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalDashboardSearchResponse>(null as any);
    }

    /**
     * @param isDurationSort (optional) 
     * @param agentID (optional) 
     * @param carrierID (optional) 
     * @param policyNumber (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalDashboardAsExcel(v: string, isDurationSort?: boolean | undefined, agentID?: number | null | undefined, carrierID?: number | undefined, policyNumber?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getrenewaldashboardasexcel?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (isDurationSort === null)
            throw new Error("The parameter 'isDurationSort' cannot be null.");
        else if (isDurationSort !== undefined)
            url_ += "IsDurationSort=" + encodeURIComponent("" + isDurationSort) + "&";
        if (agentID !== undefined && agentID !== null)
            url_ += "AgentID=" + encodeURIComponent("" + agentID) + "&";
        if (carrierID === null)
            throw new Error("The parameter 'carrierID' cannot be null.");
        else if (carrierID !== undefined)
            url_ += "CarrierID=" + encodeURIComponent("" + carrierID) + "&";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalDashboardAsExcel(_response);
        });
    }

    protected processGetRenewalDashboardAsExcel(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param policyId (optional) 
     * @param renewalId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalEditor(v: string, policyId?: number | undefined, renewalId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalEditorResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getrenewaleditor?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "PolicyId=" + encodeURIComponent("" + policyId) + "&";
        if (renewalId === null)
            throw new Error("The parameter 'renewalId' cannot be null.");
        else if (renewalId !== undefined)
            url_ += "RenewalId=" + encodeURIComponent("" + renewalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalEditor(_response);
        });
    }

    protected processGetRenewalEditor(response: Response): Promise<RenewalEditorResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalEditorResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalEditorResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalModel> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalById(_response);
        });
    }

    protected processGetRenewalById(response: Response): Promise<RenewalModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param idQuery (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteRenewal(v: string, idPath: string, idQuery?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/{id}?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRenewal(_response);
        });
    }

    protected processDeleteRenewal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    addRenewal(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: RenewalModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddRenewal(_response);
        });
    }

    protected processAddRenewal(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateRenewal(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: RenewalModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRenewal(_response);
        });
    }

    protected processUpdateRenewal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fromPolicyId (optional) 
     * @param toPolicyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    movePolicyRenewals(v: string, fromPolicyId?: number | undefined, toPolicyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/movepolicyrenewals?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fromPolicyId === null)
            throw new Error("The parameter 'fromPolicyId' cannot be null.");
        else if (fromPolicyId !== undefined)
            url_ += "fromPolicyId=" + encodeURIComponent("" + fromPolicyId) + "&";
        if (toPolicyId === null)
            throw new Error("The parameter 'toPolicyId' cannot be null.");
        else if (toPolicyId !== undefined)
            url_ += "toPolicyId=" + encodeURIComponent("" + toPolicyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMovePolicyRenewals(_response);
        });
    }

    protected processMovePolicyRenewals(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param payDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllRenewalBackoutCarriers(v: string, payDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewalbackoutcarriers?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (payDate === null)
            throw new Error("The parameter 'payDate' cannot be null.");
        else if (payDate !== undefined)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllRenewalBackoutCarriers(_response);
        });
    }

    protected processGetAllRenewalBackoutCarriers(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param carrierID (optional) 
     * @param agentId (optional) 
     * @param payDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyNumberLookup(v: string, searchText?: string | null | undefined, carrierID?: number | null | undefined, agentId?: number | undefined, payDate?: Date | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getpolicyNumberlookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (carrierID !== undefined && carrierID !== null)
            url_ += "CarrierID=" + encodeURIComponent("" + carrierID) + "&";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (payDate !== undefined && payDate !== null)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyNumberLookup(_response);
        });
    }

    protected processGetPolicyNumberLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param carrierID (optional) 
     * @param payDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentLookup(v: string, searchText?: string | null | undefined, carrierID?: number | undefined, payDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/getagentlookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (carrierID === null)
            throw new Error("The parameter 'carrierID' cannot be null.");
        else if (carrierID !== undefined)
            url_ += "CarrierID=" + encodeURIComponent("" + carrierID) + "&";
        if (payDate === null)
            throw new Error("The parameter 'payDate' cannot be null.");
        else if (payDate !== undefined)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentLookup(_response);
        });
    }

    protected processGetAgentLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param policyNumber (optional) 
     * @param payToAgentID (optional) 
     * @param carrierID (optional) 
     * @param payDate (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCommissionsForBackOut(v: string, policyNumber?: string | null | undefined, payToAgentID?: number | null | undefined, carrierID?: number | null | undefined, payDate?: Date | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionsForBackOutSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/commissionsforbackout?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (payToAgentID !== undefined && payToAgentID !== null)
            url_ += "PayToAgentID=" + encodeURIComponent("" + payToAgentID) + "&";
        if (carrierID !== undefined && carrierID !== null)
            url_ += "CarrierID=" + encodeURIComponent("" + carrierID) + "&";
        if (payDate !== undefined && payDate !== null)
            url_ += "PayDate=" + encodeURIComponent(payDate ? "" + payDate.toISOString() : "") + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCommissionsForBackOut(_response);
        });
    }

    protected processGetAllCommissionsForBackOut(response: Response): Promise<CommissionsForBackOutSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionsForBackOutSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionsForBackOutSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    backOutSelectedCommissions(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: BackOutSeletedCommissionsRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/backoutselectedcommissions";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackOutSelectedCommissions(_response);
        });
    }

    protected processBackOutSelectedCommissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    backOutAllCommissions(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: BackOutAllCommissionsRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/backoutallcommissions";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackOutAllCommissions(_response);
        });
    }

    protected processBackOutAllCommissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalImportNamesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/renewalimportnameslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalImportNamesLookup(_response);
        });
    }

    protected processGetRenewalImportNamesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional) 
     * @param importName (optional) 
     * @param fileFormatExport (optional) 
     * @param importId (optional) 
     * @return Success
     */
    importRenewals(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined, importName?: string | null | undefined, fileFormatExport?: FileType | undefined, importId?: string | null | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/importrenewals";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (importName !== null && importName !== undefined)
            content_.append("ImportName", importName.toString());
        if (fileFormatExport === null || fileFormatExport === undefined)
            throw new Error("The parameter 'fileFormatExport' cannot be null.");
        else
            content_.append("FileFormatExport", fileFormatExport.toString());
        if (importId !== null && importId !== undefined)
            content_.append("ImportId", importId.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportRenewals(_response);
        });
    }

    protected processImportRenewals(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param commissionPlanId (optional) 
     * @param policyId (optional) 
     * @param basis (optional) 
     * @param basisOverride (optional) 
     * @param issueAge (optional) 
     * @param duration (optional) 
     * @param flatRateFactor (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCalculatedCommissionPayable(v: string, commissionPlanId?: number | undefined, policyId?: number | undefined, basis?: number | undefined, basisOverride?: number | undefined, issueAge?: number | undefined, duration?: number | undefined, flatRateFactor?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CalculatedCommissionPayableResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/calculateCommissionPayable?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (commissionPlanId === null)
            throw new Error("The parameter 'commissionPlanId' cannot be null.");
        else if (commissionPlanId !== undefined)
            url_ += "CommissionPlanId=" + encodeURIComponent("" + commissionPlanId) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "PolicyId=" + encodeURIComponent("" + policyId) + "&";
        if (basis === null)
            throw new Error("The parameter 'basis' cannot be null.");
        else if (basis !== undefined)
            url_ += "Basis=" + encodeURIComponent("" + basis) + "&";
        if (basisOverride === null)
            throw new Error("The parameter 'basisOverride' cannot be null.");
        else if (basisOverride !== undefined)
            url_ += "BasisOverride=" + encodeURIComponent("" + basisOverride) + "&";
        if (issueAge === null)
            throw new Error("The parameter 'issueAge' cannot be null.");
        else if (issueAge !== undefined)
            url_ += "IssueAge=" + encodeURIComponent("" + issueAge) + "&";
        if (duration === null)
            throw new Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (flatRateFactor === null)
            throw new Error("The parameter 'flatRateFactor' cannot be null.");
        else if (flatRateFactor !== undefined)
            url_ += "FlatRateFactor=" + encodeURIComponent("" + flatRateFactor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCalculatedCommissionPayable(_response);
        });
    }

    protected processGetCalculatedCommissionPayable(response: Response): Promise<CalculatedCommissionPayableResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalculatedCommissionPayableResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculatedCommissionPayableResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getBackoutRenewalImports(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<BackoutRenewalImportSearchResponse> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/backoutrenewalimports";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBackoutRenewalImports(_response);
        });
    }

    protected processGetBackoutRenewalImports(response: Response): Promise<BackoutRenewalImportSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BackoutRenewalImportSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackoutRenewalImportSearchResponse>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param importDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    backoutRenewalImport(v: string, carrierId?: number | undefined, importDate?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/commission/v{v}/renewals/backoutrenewalimport?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (importDate !== undefined && importDate !== null)
            url_ += "ImportDate=" + encodeURIComponent("" + importDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBackoutRenewalImport(_response);
        });
    }

    protected processBackoutRenewalImport(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface FuneralHomeStatementListModel {
    payToId?: number;
    payToName?: string | undefined;
    payDate?: Date;
}

export interface FuneralHomeStatementSearchResponse {
    recordCount?: number;
    emailAllRecords?: FuneralHomeStatementListModel[] | undefined;
    data?: FuneralHomeStatementListModel[] | undefined;
}

export interface RemoveFuneralHomeStatement {
    payToId?: number;
    payDate?: Date;
}

export interface RemoveFuneralHomeStatementsRequest {
    statements?: RemoveFuneralHomeStatement[] | undefined;
}

export interface RunCommissionsListModel {
    carrierId?: number;
    carrierName?: string | undefined;
    succeededRecordCount?: number;
    failedRecordCount?: number;
    recordCount?: number;
}

export interface RunCommissionsSearchResponse {
    recordCount?: number;
    emailAllRecords?: RunCommissionsListModel[] | undefined;
    data?: RunCommissionsListModel[] | undefined;
}

export interface PayToAgentLookupModel {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    awNs?: string[] | undefined;
}

export interface PayToAgentSearchResponse {
    recordCount?: number;
    emailAllRecords?: PayToAgentLookupModel[] | undefined;
    data?: PayToAgentLookupModel[] | undefined;
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface CommissionPlanListModel {
    id?: number;
    name?: string | undefined;
    status?: string | undefined;
    carrierName?: string | undefined;
    description?: string | undefined;
    carrierId?: number;
    paymentSourceId?: number;
    paymentMethodId?: number;
    statusId?: number;
    paymentSource?: string | undefined;
    paymentMethod?: string | undefined;
}

export interface CommissionPlanSearchResponse {
    recordCount?: number;
    emailAllRecords?: CommissionPlanListModel[] | undefined;
    data?: CommissionPlanListModel[] | undefined;
}

export interface CommisionDetailsModel {
    id?: number;
    commissionId?: number | undefined;
    ssn?: string | undefined;
    agentName?: string | undefined;
    agentId?: number | undefined;
    payToId?: number | undefined;
    type?: string | undefined;
    a01?: number | undefined;
    a02?: number | undefined;
    a03?: number | undefined;
    a04?: number | undefined;
    a05?: number | undefined;
    a06?: number | undefined;
    a07?: number | undefined;
    a08?: number | undefined;
    a09?: number | undefined;
    a10?: number | undefined;
    p01?: number | undefined;
    p02?: number | undefined;
    p03?: number | undefined;
    p04?: number | undefined;
    p05?: number | undefined;
    p06?: number | undefined;
    p07?: number | undefined;
    p08?: number | undefined;
    p09?: number | undefined;
    p10?: number | undefined;
    payFromProfit?: boolean;
}

export interface RenewalRateDetailsModel {
    id?: number;
    ageId?: number;
    agentId?: number;
    agentName?: string | undefined;
    payToAgentId?: number;
    startMonth?: number;
    stopMonth?: number;
    rate?: number;
    isFlatRate?: boolean;
    flatRateAmount?: number;
    payFromID?: number;
    hidePremiumAndRate?: boolean;
    hideAllExceptAmount?: boolean;
}

export interface RenewalAgeDetailsModel {
    id?: number;
    planId?: number | undefined;
    age1?: number | undefined;
    age2?: number | undefined;
    renewalRate?: RenewalRateDetailsModel[] | undefined;
}

export interface DeletedListModel {
    id?: number;
    name?: string | undefined;
}

export interface CommissionPlanModel {
    id?: number;
    carrierId?: number;
    name?: string | undefined;
    description?: string | undefined;
    statusId?: number;
    paymentSourceId?: number;
    paymentMethodId?: number;
    alwaysShow?: boolean;
    commisionDetails?: CommisionDetailsModel[] | undefined;
    renewalAge?: RenewalAgeDetailsModel[] | undefined;
    deletedList?: DeletedListModel[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface CommissionLevelModel {
    readonly levelId?: number;
    readonly levelType?: string | undefined;
    readonly agentId?: number;
    readonly agentSSN?: string | undefined;
    readonly agentName?: string | undefined;
    readonly a01?: number | undefined;
    readonly a02?: number | undefined;
    readonly p01?: number | undefined;
    readonly p02?: number | undefined;
}

export interface CommissionPlanUsagePaymentPlan {
    paymentPlanId?: number;
    productName?: string | undefined;
    agentId?: number;
    agentName?: string | undefined;
}

export interface CommissionPlanUsageModel {
    paymentPlans?: CommissionPlanUsagePaymentPlan[] | undefined;
    paymentPlanCount?: number;
    policiesCount?: number;
}

export interface CommissionPlanUsagePolicy {
    policyId?: number;
    policyNumber?: string | undefined;
    productName?: string | undefined;
    agentName?: string | undefined;
    customerName?: string | undefined;
}

export interface RenewalRateModel {
    agentName?: string | undefined;
    startMonth?: number;
    stopMonth?: number;
    rate?: number;
    payFromName?: string | undefined;
    isFlatRate?: boolean;
    flatRateAmount?: number;
}

export interface RenewalRateResponse {
    recordCount?: number;
    emailAllRecords?: RenewalRateModel[] | undefined;
    data?: RenewalRateModel[] | undefined;
}

export interface RenewalAgeModel {
    id?: number;
    renewalAgeStartAge?: number;
    renewalAgeStopAge?: number;
}

export interface RenewalAgeResponse {
    recordCount?: number;
    emailAllRecords?: RenewalAgeModel[] | undefined;
    data?: RenewalAgeModel[] | undefined;
}

export interface CommissionScreenLookupResponse {
    paymentSource?: ListItem[] | undefined;
    paymentMethod?: ListItem[] | undefined;
    planStatus?: ListItem[] | undefined;
}

export interface CommissionStatementListModel {
    payDate?: Date;
    divisionID?: number;
    divisionName?: string | undefined;
    isPaid?: boolean;
    isApproved?: boolean;
}

export interface CommissionStatementSearchResponse {
    recordCount?: number;
    emailAllRecords?: CommissionStatementListModel[] | undefined;
    data?: CommissionStatementListModel[] | undefined;
}

export enum StatementType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum StatementFileType {
    _0 = 0,
    _1 = 1,
}

export interface DownloadFileModel {
    data?: string | undefined;
    message?: string | undefined;
    fileName?: string | undefined;
}

export interface ExistingPoliciesListModel {
    id?: number;
    policyNumber?: string | undefined;
    effectiveDate?: Date;
    status?: string | undefined;
    productName?: string | undefined;
    customerName?: string | undefined;
    agentID?: number;
    customerID?: number;
    originalEffectiveDate?: Date;
}

export interface ExistingPoliciesSearchResponse {
    data?: ExistingPoliciesListModel[] | undefined;
}

export interface NonActivatedPoliciesListModel {
    id?: number;
    agentId?: number;
    policyNumber?: string | undefined;
    effectiveDate?: Date;
    status?: string | undefined;
    productName?: string | undefined;
    customerName?: string | undefined;
}

export interface NonActivatedPoliciesSearchResponse {
    data?: NonActivatedPoliciesListModel[] | undefined;
}

export interface PaymentPlansConfigurationListModel {
    paymentPlanID?: number;
    productName?: string | undefined;
    commissionPlanName?: string | undefined;
}

export interface PaymentPlansConfigurationResponse {
    data?: PaymentPlansConfigurationListModel[] | undefined;
}

export interface PolicyCommissionType {
    id?: number;
    name?: string | undefined;
    factor?: number;
}

export interface PolicyCommissionTypeResponse {
    commissionTypes?: PolicyCommissionType[] | undefined;
}

export interface PolicyDashboardConfigurationListModel {
    policyImportID?: number;
    customerLastName?: string | undefined;
    customerFirstName?: string | undefined;
    productName?: string | undefined;
    agentName?: string | undefined;
    agentWritingNumber?: string | undefined;
    policyNumber?: string | undefined;
    effectiveDate?: string | undefined;
    birthDay?: string | undefined;
    phoneNumber?: string | undefined;
    productID?: number;
    originalDateEffective?: string | undefined;
    policyStatus?: string | undefined;
}

export interface PolicyDashboardConfigurationResponse {
    recordCount?: number;
    emailAllRecords?: PolicyDashboardConfigurationListModel[] | undefined;
    data?: PolicyDashboardConfigurationListModel[] | undefined;
}

export interface CreatePolicyModel {
    policyImportId?: number;
    paymentPlanId?: number;
    commissionTypeId?: number;
    licenseNumber?: string | undefined;
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface RenewalRecordCountListModel {
    carrier?: string | undefined;
    recordCount?: number;
}

export interface RenewalRecordCountResponse {
    recordCount?: number;
    emailAllRecords?: RenewalRecordCountListModel[] | undefined;
    data?: RenewalRecordCountListModel[] | undefined;
}

export interface RenewalReviewLogSpModel {
    renewalID?: number;
    user?: string | undefined;
    policy?: string | undefined;
    fi?: string | undefined;
    lastName?: string | undefined;
    product?: string | undefined;
    premium?: number | undefined;
    duration?: number;
    dateCreated?: Date | undefined;
}

export interface RenewalReviewLogResponse {
    recordCount?: number;
    emailAllRecords?: RenewalReviewLogSpModel[] | undefined;
    data?: RenewalReviewLogSpModel[] | undefined;
}

export interface RenewalFlatRateCalculationResponse {
    flatRate?: number;
    resultCaption?: string | undefined;
    isEditable?: boolean;
}

export interface PolicyInfoListModel {
    readonly policyID?: number;
    readonly policyNumber?: string | undefined;
    readonly effectiveDate?: any | undefined;
    readonly createdDate?: any | undefined;
    readonly agent?: string | undefined;
    readonly status?: string | undefined;
    readonly product?: string | undefined;
    readonly company?: string | undefined;
}

export interface PoliciesByPolicyNumberResponse {
    recordCount?: number;
    emailAllRecords?: PolicyInfoListModel[] | undefined;
    data?: PolicyInfoListModel[] | undefined;
}

export interface PoliciesBySearchTermResponse {
    policyNumbers?: string[] | undefined;
}

export interface PolicyRenewalCommissionListModel {
    commissionID?: number;
    datePaid?: string | undefined;
    renewalMonth?: string | undefined;
    paid?: string | undefined;
    premium?: number;
    commission?: number;
    rate?: number;
    paidTo?: string | undefined;
    paymentSourceName?: string | undefined;
    flatRateAmount?: number;
    advance?: string | undefined;
}

export interface PolicyRenewalCommissionsResponse {
    recordCount?: number;
    emailAllRecords?: PolicyRenewalCommissionListModel[] | undefined;
    data?: PolicyRenewalCommissionListModel[] | undefined;
    totalCommissionPaid?: number;
}

export interface RenewalDashboardListModel {
    renewalID?: number;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    issueDate?: Date | undefined;
    carrierID?: number | undefined;
    carrierName?: string | undefined;
    premium?: number;
    premiumOverride?: number;
    duration?: number;
    agentID?: number | undefined;
    agentFirstName?: string | undefined;
    agentLastName?: string | undefined;
    recentlyModified?: boolean;
    readonly policyID?: number;
    policyPremium?: number;
    commissionReceived?: string | undefined;
    commissionPlan?: string | undefined;
    payeesOnPlan?: number | undefined;
    commissionPayable?: number | undefined;
    commissionPlanPayees?: string | undefined;
}

export interface RenewalDashboardSearchResponse {
    recordCount?: number;
    emailAllRecords?: RenewalDashboardListModel[] | undefined;
    data?: RenewalDashboardListModel[] | undefined;
}

export interface RenewalEditorResponse {
    policyNumber?: string | undefined;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    carrierName?: string | undefined;
    carrierId?: number;
    productName?: string | undefined;
    modeName?: string | undefined;
    canProRate?: boolean;
    policyRenewalReminderNote?: string | undefined;
    proRateCaption?: string | undefined;
    renewalPolicyID?: number;
    renewalID?: number;
    renewalTypeID?: number;
    renewalPaymentSourceString?: string | undefined;
    renewalFlatRateFactor?: number;
    renewalPremium?: number;
    renewalPremiumOverride?: number;
    renewalRowVersion?: string | undefined;
    renewalIsEditable?: boolean;
    renewalCommissionPlanID?: number;
    flatRateRenewalCommissionPlanID?: number;
    flatRateRenewalIssueAge?: number;
    flatRatePolicyProductID?: number;
    flatRatePolicyEffectiveDate?: Date;
    flatRateFlatRateMonth?: number;
    flatRateUseFlatRateMonth?: boolean;
    flatRateDuration?: number;
    statementDate?: Date | undefined;
    commissionReceived?: string | undefined;
    policyPremium?: number | undefined;
    commissionPayable?: number | undefined;
    payeesOnPlan?: number | undefined;
    commissionPlanPayees?: string | undefined;
    revenueNote?: string | undefined;
    commissionPlans?: ListItem[] | undefined;
}

export interface RenewalModel {
    id?: number;
    renewalCommissionPlanId?: number;
    duration?: number;
    flatRateFactor?: number;
    renewalIssueAge?: number;
    policyId?: number;
    renewalPremium?: number;
    premiumOverride?: number;
    statementDate?: Date | undefined;
    commissionReceived?: string | undefined;
    commissionPayable?: number | undefined;
    payeesOnPlan?: number | undefined;
    commissionPlanPayees?: string | undefined;
}

export interface CommissionsForBackOutListModel {
    id?: number;
    renewalId?: number | undefined;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    productName?: string | undefined;
    policyNumber?: string | undefined;
    issueDate?: Date | undefined;
    carrierId?: number | undefined;
    carrierName?: string | undefined;
    premium?: number;
    readonly policyId?: number;
    readonly commission?: number;
    readonly payToAgentFirstName?: string | undefined;
    readonly payToAgentLastName?: string | undefined;
    readonly payToAgentId?: number;
}

export interface CommissionsForBackOutSearchResponse {
    recordCount?: number;
    emailAllRecords?: CommissionsForBackOutListModel[] | undefined;
    data?: CommissionsForBackOutListModel[] | undefined;
}

export interface BackOutSeletedCommissionsRequest {
    renewalCommissionIds?: number[] | undefined;
}

export interface BackOutAllCommissionsRequest {
    policyNumber?: string | undefined;
    payToAgentID?: number | undefined;
    carrierID?: number | undefined;
    payDate?: Date | undefined;
}

export enum FileType {
    _0 = 0,
    _1 = 1,
}

export interface CalculatedCommissionPayableResponse {
    commissionPayable?: number;
    payeesOnPlan?: number;
    payees?: string | undefined;
}

export interface BackoutRenewalImportListModel {
    carrierId?: number;
    carrierName?: string | undefined;
    dateCreated?: Date;
    dateCreatedKey?: string | undefined;
    recordCount?: number;
}

export interface BackoutRenewalImportSearchResponse {
    data?: BackoutRenewalImportListModel[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}